import { render } from "./DropdownsProviders.vue?vue&type=template&id=64530790"
import script from "./DropdownsProviders.vue?vue&type=script&lang=js"
export * from "./DropdownsProviders.vue?vue&type=script&lang=js"

import "./DropdownsProviders.vue?vue&type=style&index=0&id=64530790&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__